import { render, staticRenderFns } from "./RegTypePage.vue?vue&type=template&id=e05d350a"
import script from "./RegTypePage.vue?vue&type=script&lang=js"
export * from "./RegTypePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports